module.exports = __webpack_public_path__ + "static/media/badge-percent.34e5a815.svg";